import { Component, Input, OnInit, OnChanges } from "@angular/core";

@Component({
    selector: "svg-icon",
    templateUrl: "./svg-icon.component.html",
    styleUrls: ["svg-icon.component.scss"],
    standalone: false
})

export class SVGIconComponent implements OnInit, OnChanges {
    iconHref: string;
    showIcon: boolean = false;
    @Input() hoverText: string = "";
    _showHover: boolean = false;
    get showHover(): boolean {
        return this.hoverText != null && this.hoverText.length > 0 && this._showHover;
    }


    ngOnInit() {
        this.createHref();
    }

    /**
     * Name of the icon used in
     * the symbol-defs.svg (i.e. #icon-email)
     */
    @Input()
    icon: string;

    /**
     * Function to hide/show svg if icon name is provided and prepend hash to icon name
     */
    createHref(): void {
        //if a svg is passed we populate the svg
        if(this.icon) {
            this.showIcon = true;
            this.iconHref = "#" + this.icon;
        }
        //if nothing is passed, no svg will show
        else {
            this.showIcon = false;
        }
    }

    /**
     * Update when model changes
     */
    public ngOnChanges(): void {
        this.createHref();
    }

    onMouseover(): void {
        this._showHover = true;
    }

    onMouseout(): void {
        this._showHover = false;
    }
}